module.exports = __webpack_public_path__ + "static/media/Promotions.51603d0e.svg";